
import { defineComponent, PropType } from 'vue';
import MessageWrap from '@/components/MessageWrap/index.vue';
import Button from '@/models/ButtonModel';
import Message from '@/models/MessageModel';
import SelectChanelButton from '@/components/MessageTypes/SelectChanelRefactor/SelectChannelButton.vue';
import RequiredInputRefactor from '@/components/RequiredInputsRefactor/index.vue';
import CommonButton from '@/components/App/CommonButton/index.vue';
import DisabledButtonWrapper from '@/components/App/DisabledButtonWrapper/index.vue';

export default defineComponent({
	name: 'SelectChanelWidget',

	components: {
		DisabledButtonWrapper,
		CommonButton,
		RequiredInputRefactor,
		SelectChanelButton,
		MessageWrap
	},

	props: {
		message: {
			type: Object as PropType<Message>
		},

		isShowMessageTail: {
			type: Boolean
		},

		isLastMessage: {
			type: Boolean
		},
		avatar: {
			type: String
		},
		respondentId: {
			type: Number,
			required: true
		},
		disableButton: {
			type: Boolean
		},
		requiredInputs: {
			type: Object
		},
		showInvalidRequiredInputs: {
			type: Boolean
		},
		buttons: {
			type: Object
		}
	},
	emits: ['click-button', 'change-control'],
	methods: {
		emitClickButton(button: Button) {
			this.$emit('click-button', button);
		},
		emitChangeControl(control: object) {
			this.$emit('change-control', control);
		}
	}
});
